module.exports = __webpack_public_path__ + "img/State=1.aa57ff5a.svg";